<template>
  <div>

    <autoLogout />
    <loader :loader="loader" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-row align="center" justify="center" class="mt-4">
            <v-col cols="12" md="4" xl="6">
              <v-autocomplete v-model="idBranchOfficeSelected" no-data-text="Sin resultados" :items="listBranchOffices"
                @change="getConfigByBranchOffice" label="Seleccione sucursal" clearable
                append-icon="mdi-account-search" />
            </v-col>
          </v-row>

          <v-tabs icons-and-text centered fixed-tabs>
            <v-tab class="mt-2 mb-3">
              PACS <v-icon right>mdi-file-image</v-icon>
            </v-tab>
            <v-tab class="mt-2 mb-3">
              Archivos <v-icon right> mdi-paperclip </v-icon>
            </v-tab>
            <v-tab class="mt-2 mb-3">
              Licencia <v-icon right> mdi-calendar-multiple-check</v-icon>
            </v-tab>
            <v-tab class="mt-2 mb-3">
              Interpretación y mi estudio <v-icon right>mdi-web </v-icon>
            </v-tab>
            <v-tab class="mt-2 mb-3" @click="getConfigReception">
              Recepción <v-icon right>mdi-human</v-icon>
            </v-tab>
            <v-tab class="mt-2 mb-3" @click="getConfigClues">
              Localidad <v-icon right>mdi-home-city</v-icon>
            </v-tab>
            <v-tab-item name="pacs" class="mt-15 mb-10">
              <v-row>
                <v-col>
                  <h3 class="font-weight-black">Propiedades de conexión PACS</h3>
                </v-col>
              </v-row>
              <validation-observer ref="observer" v-slot="{ invalid }">
                <v-form ref="formPacs">
                  <v-row>
                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Usuario">
                        <v-text-field outlined dense clearable v-model="objConfig.user" label="Usuario"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Contraseña">
                        <v-text-field outlined dense clearable v-model="objConfig.password" label="Contraseña"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Host" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.hostnameDocker" label="IP Host local"
                          :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Puerto" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.port" label="Puerto"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" xl="2" sm="12">
                      <validation-provider v-slot="{ errors }" name="Protocolo" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.protocol" label="Protocolo"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Host" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.hostname" label="IP Host web"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Host web" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.hostnameWEB" label="Nombre del Host Web"
                          :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="2" sm="12">
                      <validation-provider v-slot="{ errors }" name="Nombre de PACS" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.namePacs" label="Nombre de PACS"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6" xl="2" sm="12">
                      <validation-provider v-slot="{ errors }" name="AET" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.aet" label="AET"
                          :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" md="3" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Servicio ECG python" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.urlPythonECG"
                          label="Servicio ECG python" :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="3" md="3" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Puerto HL7" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.hl7Port" label="Puerto HL7"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="3" md="3" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Puerto de WADO" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.wadoPort" label="Puerto de WADO"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="3" md="3" xl="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="TLS" rules="required">
                        <v-switch v-model="objConfig.useTLS" label="¿Usar TLS?" :error-messages="errors" required>
                        </v-switch>
                      </validation-provider>
                    </v-col>

                  </v-row>

                  <v-row align="center" justify="center" class="text-center mb-5">

                    <v-col cols="6">

                      <validation-provider v-slot="{ errors }" name="Visualizador web" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfig.pathViewerWeb" label="Visualizador web"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center" class="text-center mb-5">
                    <v-col>
                      <v-btn color="primary" :disabled="invalid" @click="addPacsConfig()">
                        Guardar <v-icon right>mdi-content-save</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </validation-observer>
            </v-tab-item>
            <v-tab-item name="files" class="mt-15 mb-10">

              <v-row>
                <v-col>
                  <h3 class="font-weight-black">
                    Propiedades de conexión de archivos
                  </h3>
                </v-col>
              </v-row>
              <validation-observer ref="observerAdd" v-slot="{ invalid }">
                <v-form ref="formAddendums">
                  <v-row>
                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Usuario">
                        <v-text-field outlined dense clearable v-model="objConfigAddendums.username" label="Usuario"
                          :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" rules="" name="Contraseña">
                        <v-text-field outlined dense clearable :append-icon="show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                          " @click:append="show = !show" :type="show ? 'text' : 'password'"
                          v-model="objConfigAddendums.pass" label="Contraseña" :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" name="Host" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfigAddendums.hostName" label="IP Host"
                          :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Puerto" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfigAddendums.port" label="Puerto"
                          :error-messages="errors" required>
                        </v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Ruta" rules="required">
                        <v-text-field outlined dense clearable v-model="objConfigAddendums.route"
                          label="Ruta de almacenamiento" :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center" class="text-center mb-5">
                    <v-col>
                      <v-btn color="primary" :disabled="invalid" @click="addAddendumsConfig()">
                        Guardar <v-icon right>mdi-content-save</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-form>
              </validation-observer>
            </v-tab-item>
            <v-tab-item name="license" class="mt-15 mb-10">
              <v-row>
                <v-col>
                  <h3 class="font-weight-black">Propiedades de licencia</h3>
                </v-col>
              </v-row>
              <validation-observer ref="observerLicense" v-slot="{ invalid }">
                <form @submit.prevent="addDateLicense()">
                  <v-row align="center" justify="center">
                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" name="Fecha de caducidad de licencia" rules="required">
                        <v-text-field outlined dense clearable v-model="date" type="date"
                          label="Fecha de caducidad de licencia*" hint="Formato DD/MM/YYYY" prepend-icon="mdi-calendar"
                          max="2099-12-31" :error-messages="errors">
                        </v-text-field>
                      </validation-provider>
                      <!--GUARDAR-->
                      <v-row align="center" justify="center" class="text-center mb-4 pt-5">
                        <v-btn id="reload" color="primary" :disabled="invalid" type="submit">
                          Guardar<v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </form>
              </validation-observer>
            </v-tab-item>
            <v-tab-item name="webapp" class="mt-15 mb-10">
              <validation-observer ref="observerWebApp" v-slot="{ invalid }">
                <form @submit.prevent="addConfigAppReport()">

                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black">Visualizador OSIRIX</h3>
                    </v-col>
                  </v-row>
                  <v-row align="left" justify="left">


                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Nombre de servidor osirix">
                        <v-text-field outlined dense clearable v-model="modelWebApp.serverNameOsirix"
                          label="Nombre de servidor osirix" :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black">Mi estudio</h3>
                    </v-col>
                  </v-row>
                  <v-row align="left" justify="left">


                    <v-col cols="12" md="4" xl="4" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Servidor de descarga">
                        <v-text-field outlined dense clearable v-model="modelWebApp.serverPath"
                          label="Servidor de descarga" :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="5" xl="5" sm="12">
                      <validation-provider v-slot="{ errors }" rules="required" name="Plataforma de paciente">
                        <v-text-field outlined dense clearable v-model="modelWebApp.appPath"
                          label="Plataforma de paciente" :error-messages="errors" required></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="2" xl="2" sm="12"  align="right" justify="right">
                      <validation-provider v-slot="{ errors }" name="Mostrar QR">
                        <v-switch v-model="modelWebApp.displayQR" label="¿Mostrar QR mi estudio?"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                  </v-row>


                  <v-row>
                    <v-col>
                      <h3 class="font-weight-black">Interpretación</h3>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <v-col cols="3" md="3" xl="3" sm="3">
                      <validation-provider v-slot="{ errors }" name="Copiar y pegar en interpretación">
                        <v-switch v-model="modelWebApp.allowCopyPaste" label="Permitir copiar y pegar en interpretación"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                    <!-- <v-col cols="3" md="3" xl="3" sm="3">
                      <validation-provider v-slot="{ errors }" name="Requieren validación">
                        <v-switch v-model="modelWebApp.validateInterpretation" label="Validar interpretación"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col> -->
                  </v-row>
                  <v-row dense>
                    <v-col cols="6" md="6" xl="6" sm="6">
                      <label>Nota complementaria (BIRADS 0 y 3)</label>
                      <validation-provider v-slot="{ errors }" name="Nota complementaria (BIRADS 0 y 3)" rules="max:300">
                        <vue-editor outlined v-model="modelWebApp.supplementaryNote03" :error-messages="errors" class="mt-4"
                          :editorToolbar="customToolbar" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="6" md="6" xl="6" sm="6">
                      <label>Nota complementaria (BIRADS 4, 5 y 6)</label>
                      <validation-provider v-slot="{ errors }" name="Nota complementaria (BIRADS 4, 5 y 6)"
                        rules="max:300">
                        <vue-editor outlined v-model="modelWebApp.supplementaryNote46" :error-messages="errors" class="mt-4"
                          :editorToolbar="customToolbar" />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense align="middle" justify="center">
                    <v-col cols="6" md="6" xl="6" sm="6">
                      <label >Nota complementaria (Conclusión mastografía)</label>
                      <validation-provider v-slot="{ errors }" name="Nota complementaria (Conclusión mastografía)" rules="max:600">
                        <vue-editor outlined v-model="modelWebApp.supplementaryConclusionMg" :error-messages="errors" class="mt-4"
                          :editorToolbar="customToolbar" />
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center" class="text-center mb-4 pt-5">
                    <v-btn id="reload" color="primary" :disabled="invalid" type="submit">
                      Guardar<v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-row>
                </form>
              </validation-observer>
            </v-tab-item>
            <v-tab-item name="reception" class="mt-15 mb-10">
              <validation-observer ref="observerReception" v-slot="{ invalid }">
                <form @submit.prevent="addConfigReception()">

                  <v-row align="center" justify="center">
                    <v-col md="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Credencial electoral">
                        <v-switch v-model="modelReception.displayVotingLicense" label="¿Mostrar credencial electoral?"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                    <v-col md="3" offset-md="1" sm="12">
                      <validation-provider v-slot="{ errors }" name="Familia">
                        <v-switch v-model="modelReception.displayFamilyInformation"
                          label="¿Capturar información de familiares?" :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                    <v-col md="3" offset-md="1" sm="12">
                      <validation-provider v-slot="{ errors }" name="QR">
                        <v-switch v-model="modelReception.displayQrStudy" label="¿Ver instrucciones de mi estudio?"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                  </v-row>


                  <v-row align="center" justify="center" class="text-center mb-4 pt-5">
                    <v-btn id="reload" color="primary" :disabled="invalid" type="submit">
                      Guardar<v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-row>
                </form>
              </validation-observer>
            </v-tab-item>
            <v-tab-item name="clues" class="mt-14 mb-09">
              <validation-observer ref="observerClues" v-slot="{ invalid }">
                <form @submit.prevent="confirmSaveConfigClues">

                  <v-row align="center" justify="center">
                    <v-col md="3" sm="12">
                      <validation-provider v-slot="{ errors }" name="Catálogo clues">
                        <v-switch v-model="modelClues.showCluesCatalog" label="¿Mostrar catálogo de CLUES?"
                          :error-messages="errors">
                        </v-switch>
                      </validation-provider>
                    </v-col>
                  </v-row>


                  <v-row align="center" justify="center" class="text-center mb-4 pt-5">
                    <v-btn id="reload" color="primary" :disabled="invalid" type="submit">
                      Guardar<v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                  </v-row>
                </form>
                <v-dialog v-model="confirmCluesDialog" max-width="520" persistent>
                  <v-card>
                    <v-card-title class="headline">Confirmar guardado</v-card-title>
                    <v-card-text>{{ cluesConfirmText }}</v-card-text>
                        <v-card-actions class="px-6 pb-4 justify-center">
                          <v-btn
                            outlined
                            color="red darken-1"
                            class="mx-2 px-6"
                            :style="{ minWidth: '160px' }"
                            @click="confirmCluesDialog = false"
                          >
                            CANCELAR
                          </v-btn>

                          <v-btn
                            outlined
                            color="green darken-1"
                            class="mx-2 px-6"
                            :style="{ minWidth: '160px' }"
                            @click="proceedSaveClues"
                          >
                            GUARDAR
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
              </validation-observer>
            </v-tab-item>
          </v-tabs>
          <!-- <v-row align="center" justify="center">
            <v-col cols="10" class="text-center">
              <v-row align="center" justify="center">
                <v-col>
                  <v-btn plain color="error">
                    <v-icon left>mdi-chevron-left</v-icon> Volver
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row> -->
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import { PacsConfigurationRequest, LocationRequest } from "@/core/request";
import { VueEditor } from "vue2-editor";

import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";
import moment from "moment";

import AutoLogout from "../../components/AutoLogout.vue";
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("regex", {
  ...regex,
  message: "El formato del campo {_field_} no es válido",
});
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar.vue";
import Loader from "../../components/Loader.vue";
export default {
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Loader,
    VueEditor,
    AutoLogout,
  },
  name: "PACSConfig",
  data: (vm) => ({
    customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["code-block"]
    ],
    loader: false,
    date: null,
    value: null,
    encabezado: { icono: "mdi-server-network", texto: "Preferencias" },
    objConfig: {
      aet: "",
      hostname: "",
      port: "",
      password: "",
      wadoPort: "",
      hl7Port: "",
      protocol: "",
      user: "",
      useTLS: "",
      namePacs: "",
      idBranchOffice: "",
      pathViewerWeb: ""
    },
    objConfigAddendums: {
      hostName: "",
      port: "",
      password: "",
      username: "",
      route: "",
      idBranchOffice: "",
    },
    modelWebApp: {
      serverPath: "",
      appPath: "",
      displayQR: "false",
      allowCopyPaste: "false",
      validateInterpretation: "false"
    },
    modelReception: {
      displayVotingLicense: false,
      displayQrStudy: false,
      displayFamilyInformation: false,
    },
    modelClues: {
      showCluesCatalog: null
    },
    currentDate: moment().format("YYYY-MM-DD"),
    show: false,
    listBranchOffices: [],
    idBranchOfficeSelected: "",
    confirmCluesDialog: false
  }),
  created() {
    this.idBranchOfficeSelected = this.$utilFront.getIdBranchOffice();
    this.getPacsConfig();
    this.getConfigAddendum();
    this.listBranchOffice();
    this.getDateLincen();
    this.getConfigAppReport();
    //this.getAllConfig();
  },
  computed: {
  cluesConfirmText() {
    return this.modelClues.showCluesCatalog
      ? 'Se guardará la configuración con el catálogo de CLUES habilitado.'
      : 'Se guardará la configuración con el catálogo de CLUES deshabilitado.';
  }
},
  methods: {
    cleanModal() {
      this.$refs?.formPacs?.reset();
      this.$refs?.formAddendums?.resetValidation();
      this.$refs?.formAddlicense?.resetValidation();
    },
    getPacsConfig() {
      this.loader = true;
      try {
        PacsConfigurationRequest.listPacsConfigurationsByBranchOffice({
          idBranchOffice: this.idBranchOfficeSelected,
        }).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.objConfig = res.data.data;
            this.objConfig.useTLS = (this.objConfig.useTLS === 'true');
          }
        });
      } catch (e) {
      } finally {
        this.loader = false;
      }
    },
    addPacsConfig() {
      if (!this.loader) {
        let data = this.objConfig;

        let objConfigPost = {
          aet: data.aet,
          hostname: data.hostname,
          port: data.port,
          password: data.password,
          wadoPort: data.wadoPort,
          hl7Port: data.hl7Port,
          protocol: data.protocol,
          user: data.user,
          useTLS: data.useTLS.toString(),
          namePacs: data.namePacs,
          hostnameWEB: data.hostnameWEB,
          hostnameDocker: data.hostnameDocker,
          idBranchOffice: this.idBranchOfficeSelected,
          urlPythonECG: data.urlPythonECG,
          pathViewerWeb: data.pathViewerWeb
        };

        PacsConfigurationRequest.addPacsConfigurations(objConfigPost)
          .then((res) => {
            this.loader = true;
            if (res.data.code == 200) {
              this.$utilFront.notifications(
                "Configuración de PACS guardada correctamente",
                "SUCCESS"
              );
            } else if (res.data.code == 401) {
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    addDateLicense() {

      let data = {
        value: moment(this.date, "yyyy-MM-DD").format("DD/MM/YYYY"),
        branchOffice: {
          idBranchOffice: this.idBranchOfficeSelected,
        },
      };
      PacsConfigurationRequest.addDateLicense(data)
        .then((res) => {
          this.loader = true;
          if (res) {
            this.$utilFront.notifications(
              "Fecha de caducidad de licencia guardada correctamente",
              "SUCCESS"
            );
          }
        })
        .finally(() => {
          this.loader = false;
          location.reload()

        });
    },

    getDateLincen() {
      PacsConfigurationRequest.getLicense()
        .then((response) => {
          let { date } = response.data.data;
          this.date = moment(date, "DD/MM/YYYY").format("yyyy-MM-DD");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAddendumsConfig() {
      if (!this.loader) {
        let data = this.objConfigAddendums;
        let objConfigPost = {};
        if (data.pass === "") {
          objConfigPost = {
            hostName: data.hostName,
            port: data.port,
            password: data.password,
            username: data.username,
            route: data.route,
            idBranchOffice: this.idBranchOfficeSelected,
          };
        } else {
          objConfigPost = {
            hostName: data.hostName,
            port: data.port,
            password: data.pass,
            username: data.username,
            route: data.route,
            idBranchOffice: this.idBranchOfficeSelected,
          };
        }

        PacsConfigurationRequest.addAddendumsConfiguration(objConfigPost)
          .then((res) => {
            this.loader = true;
            if (res) {
              this.$utilFront.notifications(
                "Configuración de archivos guardada correctamente",
                "SUCCESS"
              );
            }
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    getConfigAddendum() {
      this.loader = true;
      try {
        PacsConfigurationRequest.listAddendumConfigurationsByBranchOffice({
          idBranchOffice: this.idBranchOfficeSelected,
        }).then((res) => {
          if (res.data.data != null) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.objConfigAddendums = res.data.data;
              this.objConfigAddendums.pass = "";
            } else {
              this.objConfigAddendums = {};
            }
          }
        });
      } catch (e) {
      } finally {
        this.loader = false;
      }
    },
    getConfigAppReport() {

      this.loader = true;
      let data = { idBranchOffice: this.idBranchOfficeSelected };

      PacsConfigurationRequest.getConfigAppReport(data).then((res) => {
        if (res.data.code === 200) {
          this.modelWebApp = res.data.data;
          this.modelWebApp.displayQR = (this.modelWebApp.displayQR === 'true')
          this.modelWebApp.allowCopyPaste = (this.modelWebApp.allowCopyPaste === 'true')
          this.modelWebApp.validateInterpretation = (this.modelWebApp.validateInterpretation === 'true')
        } else {
          this.$utilFront.notifications("Error al obtener la configuración", "ERROR");
        }
      }).finally(() => {
        this.loader = false;
      });

    },
    getConfigReception() {

      this.loader = true;
      let data = { idBranchOffice: this.idBranchOfficeSelected };

      PacsConfigurationRequest.getConfigReception(data).then((res) => {
        if (res.data.code === 200) {
          this.modelReception = res.data.data;
          this.modelReception.displayVotingLicense = (this.modelReception.displayVotingLicense === true)
        } else {
          this.$utilFront.notifications("Error al obtener la configuración", "ERROR");
        }
      }).finally(() => {
        this.loader = false;
      });

    },
    getConfigClues() {
  this.loader = true;

  const data = {
    idBranchOffice: this.$utilFront.getIdBranchOffice()
  };

  LocationRequest.getClues(data)
    .then((res) => {
      if (res.data.code === 200) {
        const cfg = res.data.data || {};
        const raw = cfg.displayCluesCatalogue;
        this.modelClues.showCluesCatalog = (raw === true || raw === 'true' || raw === 1 || raw === '1');
      } else {
        this.$utilFront.notifications("Error al obtener la configuración", "ERROR");
      }
    })
    .catch((err) => {
      console.error("Error al obtener la configuración de CLUES:", err);
      this.$utilFront.notifications("Error al obtener la configuración", "ERROR");
    })
    .finally(() => {
      this.loader = false;
    });
},
    addConfigAppReport() {
      if (!this.loader) {
        this.loader = true;
        let data = Object.assign({}, this.modelWebApp);
        data.displayQR = `${data.displayQR}`;
        data.allowCopyPaste = `${data.allowCopyPaste}`;
        data.validateInterpretation = `${data.validateInterpretation}`;
        data.idBranchOffice = this.idBranchOfficeSelected;

        PacsConfigurationRequest.addConfigAppReport(data).then((res) => {
          if (res.data.code === 200) {
            this.$utilFront.notifications("Configuración guardada correctamente.", "SUCCESS");
          } else {
            this.$utilFront.notifications(res.data.data || "Error al guardar la configuración", "ERROR");
          }
        }).finally(() => {
          this.loader = false;
        });
      }
    },
    addConfigReception() {
      if (!this.loader) {
        this.loader = true;
        let data = Object.assign({}, this.modelReception);
        // data.displayVotingLicense = `${data.displayVotingLicense}`;
        data.idBranchOffice = this.idBranchOfficeSelected;

        PacsConfigurationRequest.addConfigReception(data).then((res) => {
          if (res.data.code === 200) {
            this.$utilFront.notifications("Configuración guardada correctamente.", "SUCCESS");
          } else {
            this.$utilFront.notifications(res.data.data || "Error al guardar la configuración", "ERROR");
          }
        }).finally(() => {
          this.loader = false;
        });
      }
    },
    confirmSaveConfigClues() {
    this.confirmCluesDialog = true;
  },
  proceedSaveClues() {
    this.confirmCluesDialog = false;
    this.saveConfigClues();
  },
    saveConfigClues() {
      this.loader = true;

      const data = {
        idBranchOffice: this.$utilFront.getIdBranchOffice(),
        displayCluesCatalogue: !!this.modelClues.showCluesCatalog
      };

      LocationRequest.saveClues(data).then((res) => {
        if (res.data.code === 200) {
          this.$utilFront.notifications("Configuración guardada correctamente.", "SUCCESS");
        } else {
          this.$utilFront.notifications("Error al guardar la configuración", "ERROR");
        }
      }).finally(() => {
        this.loader = false;
      });
    },
    /* confirmSaveConfigClues() {
    const willEnable = !!this.modelClues.showCluesCatalog;
    const text = willEnable
      ? 'Se guardará la configuración con el catálogo de CLUES habilitado.'
      : 'Se guardará la configuración con el catálogo de CLUES deshabilitado.';

    this.$swal.fire({
      title: '¿Confirmar guardado?',
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      focusCancel: true
      // opcional: confirmButtonColor: '#1976D2' // Vuetify primary
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        this.saveConfigClues();
      }
    });
  }, */
    getConfigByBranchOffice() {
      this.cleanModal();
      this.getConfigAddendum();
      this.getPacsConfig();
      this.getConfigAppReport();
      this.getConfigReception();
      this.getDateLincen();
    },

    getAllConfig() {
      this.loader = true;
      try {
        this.idBranchOfficeSelected = this.$utilFront.getIdBranchOffice();

        PacsConfigurationRequest.listConfigurationsByBranchOffice({
          idBranchOffice: this.idBranchOfficeSelected,
        }).then((res) => {
          if (res.data.data != null) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.objConfig = res.data.data.pacsServerDTO;
              this.objConfigAddendums = res.data.data.addendumDTO;
              this.objConfigAddendums.pass = "";
              this.loader = false;
            }
          }
        });
      } catch (e) {
      } finally {
        this.loader = false;
      }
    },

    listBranchOffice() {
      this.listBranchOffices = this.$utilFront.getBranchOffices().map((it) => {
        return { text: it.branchOfficeName, value: it.idBranchOffice };
      });
    },
  },
};
</script>
